module.exports = __webpack_public_path__ + "static/media/view1.5be880f1.jpg";